<template>
  <div class="slide slide4 zoom" ref="main_house" v-parallax-fit="parallax"></div>
</template>

<script>
export default {
  name: 'slide4',
  mounted() {
    const evidence = {
      items: [
        {
          image: '/themes/rise-theme/dist/images/estate/character-view/vanessa/evidence/2.jpg',
          url: 'https://www.urban.org/urban-wire/are-gains-black-homeownership-history',
          link_title: {
			'en': 'Are gains in black homeownership history?',
			'es': '¿Están las ganancias en la historia de la propiedad de vivienda de los negros?'
		  },
        }
      ],
      text: {
		'en': 'In the three decades after the Fair Housing Act passed, black homeownership rose by almost six percentage points, even reaching a high of 66.3% in 1999. Yet, from 2000 to 2015, that gain was more than erased as forces within and beyond the housing market aligned to reduce the black homeownership rate to 41.2%.',
		'es': 'En las tres décadas posteriores a la aprobación de la Ley de Vivienda Justa, la propiedad de vivienda de los afroamericanos aumentó en casi seis puntos porcentuales, incluso alcanzando un máximo del 66,3 % en 1999. Sin embargo, de 2000 a 2015, esa ganancia se borró con creces a medida que las fuerzas dentro y más allá de la vivienda mercado alineado para reducir la tasa de propiedad de vivienda negra al 41,2%.'
	  }
    };
    const text = {
		'en': 'Just like Vanessa, many Americans dream of owning a home. However, because of a history of collusion between corporations, lobby groups, and racist policies, pathways for homeownership for people of color are full of barriers. Often the options available can be expensive, burdensome, or even predatory.',
		'es': 'Al igual que Vanessa, muchos estadounidenses sueñan con tener una casa propia. Sin embargo, debido a una historia de colusión entre corporaciones, grupos de presión y políticas racistas, los caminos para la propiedad de vivienda para personas de color están llenos de barreras. A menudo, las opciones disponibles pueden ser costosas, onerosas o incluso depredadoras.'
	};
    this.mutationObserver = new window.MutationObserver(mutationList => {
      mutationList.forEach( mutation => {
        if(mutation.target.style.transform == 'translateY(120px) rotateZ(0deg)') {
          this.$evidence.value = JSON.stringify(evidence);
          this.$readMore.value = text;
        }
      });
    });

    this.mutationObserver.observe(document.querySelector('#house'), {
      attributes: true,
      attributeFilter: ['style']
    });
  },
  unmounted() {
    this.mutationObserver.disconnect();
  },
  data() {
    return {
		mutationObserver: null,
      parallax: [
        {
          start: 1600,
          end: 3000,
          fromStyle: { transform: 'translateY(-1400px) rotateZ(-20deg)' },
          toStyle: { transform: 'translateY(120px) rotateZ(0deg)' },
          easing: 'linear'
        },
        {
          start: 23000,
          end: 23700,
          fromStyle: { transform: 'translateY(120px) rotateZ(0deg)' },
          toStyle: { transform: 'translateY(1800px) rotateZ(-25deg)' },
          easing: 'linear'
        },
      ]
    };
  }
}
</script>

<style lang="scss" scoped>
.slide {
    position: fixed;
    background-image: url('/themes/rise-theme/dist/images/estate/character-view/vanessa/04_House.png');
    background-position: center;
    background-size: contain;
    background-repeat: no-repeat;
    width: 941px;
    height: 650px;
    left: calc(50% - 348px);
    top: calc(50% - 415px);
    transition: 0.6s;
    z-index: 1;
    @media(max-width: 600px) {
      width: 100%;
      left: 3vw;
    }
}
</style>
